import { backendFetch } from './apiUtils';

/**
 * Business Partner filter - EORI search (?search= query param)
 */
export const getBusinessPartnerEoriAndCompany = async (searchTerm = '') => {
  const params = searchTerm ? { search: searchTerm.trim() } : {};
  return backendFetch({
    url: 'businesspartner/eori',
    params,
    method: 'GET',
  });
};

/**
 * Business Partner filter - Type dropdown options
 */
export const getBusinessPartnerTypeDropdown = async () => {
  return backendFetch({ url: 'businesspartner/typeDropdown', method: 'GET' });
};

/**
 * Business Partner filter - CABIE Status dropdown options
 */
export const getBusinessPartnerCABIEStatusDropdown = async () => {
  return backendFetch({ url: 'businesspartner/CABIEStatusDropdown', method: 'GET' });
};

/**
 * Business Partner filter - DB Status dropdown options
 */
export const getBusinessPartnerDBStatusDropdown = async () => {
  return backendFetch({ url: 'businesspartner/DBStatusDropdown', method: 'GET' });
};
